import { NONE_DEDUCTION } from "../../constants/deduction";

const checkDeductionApplied = (products) => {
  return products.some((product) => product.deduction_id !== NONE_DEDUCTION);
};
export default checkDeductionApplied;
